import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CategoryGroupForm from '../../../../components/masters/styles/categoryGroup/CategoryGroupForm';
import CategoryGroupTable from '../../../../components/masters/styles/categoryGroup/CategoryGroupTable';
import { addCategoryGroupAction, updateCategoryGroupAction, clearCategoryGroupEdit } from '../../../../redux/actions/masters/styles/categoryGroup/categoryGroupAction';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';
import { fetchCompanies } from '../../../../redux/actions/masters/company/companyAction';

// Responsive, unified container style
const outerWrapper = {
  padding: 0, // Remove extra padding from Layout
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  // background: 'transparent',
  marginTop: 24, // Add space between nav tab/breadcrumb and content
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

// Responsive adjustments
const responsiveStyle = `
@media (max-width: 900px) {
  .category-group-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .category-group-form, .category-group-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const CategoryGroupPage = () => {
  const dispatch = useDispatch();
  const { editingCategoryGroup } = useSelector((state) => state.categoryGroup);
  const users = useSelector(state => state.users.list || []);
  const companies = useSelector(state => state.company.list || []);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchCompanies());
  }, [dispatch]);

  // Handler to trigger form reset
  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccess('');
    setFormError('');
  };

  const handleSubmit = async (form) => {
    try {
      if (editingCategoryGroup && editingCategoryGroup.category_group_id) {
        await dispatch(updateCategoryGroupAction({ id: editingCategoryGroup.category_group_id, categoryGroup: form }));
        setFormError('');
      } else {
        await dispatch(addCategoryGroupAction(form));
        setFormError('');
      }
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message;
      if (
        err?.response?.status === 409 ||
        (message && message.toLowerCase().includes('already exists'))
      ) {
        setFormError('');
        throw err;
      }
      setFormError(message || 'An error occurred.');
      throw err;
    }
  };

  const handleCancel = () => {
    dispatch(clearCategoryGroupEdit());
    setFormSuccess('');
    setFormError('');
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="category-group-flex">
        <div style={tableContainer} className="category-group-table">
          <CategoryGroupTable onNew={handleFormReset} />
        </div>
        <div style={formContainer} className="category-group-form">
          <CategoryGroupForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingCategoryGroup={editingCategoryGroup}
            onCancel={handleCancel}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
            users={users}
            companies={companies}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryGroupPage; 